import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { HardHat } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate(location.state?.from?.pathname || "/", { replace: true });
  }, [user, navigate, location.state]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/", { replace: true });
    else setError(res.error);
  };

  return (
    <div className="min-h-screen flex" data-testid="login-page">
      <div className="hidden lg:block lg:w-1/2 relative">
        <img
          src="https://images.unsplash.com/photo-1608303588026-884930af2559?crop=entropy&cs=srgb&fm=jpg&q=85"
          alt="Studio di ingegneria"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-slate-900/70" />
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <h2 className="font-display text-3xl font-bold leading-tight">Gare, commesse e scadenze.<br />Tutto sotto controllo.</h2>
          <p className="mt-3 text-slate-300 text-sm max-w-md">Il gestionale dello studio: monitoraggio gare d'appalto, avanzamento commesse e carico di lavoro del team.</p>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center bg-slate-50 px-6">
        <div className="w-full max-w-sm">
          <div className="flex items-center gap-3 mb-8">
            <div className="h-11 w-11 rounded-md bg-blue-900 flex items-center justify-center">
              <HardHat className="h-6 w-6 text-white" />
            </div>
            <div>
              <h1 className="font-display text-xl font-bold text-slate-900 leading-tight">StudioNex</h1>
              <div className="text-xs text-slate-500 font-code">Gestionale 2026</div>
            </div>
          </div>
          <h2 className="text-lg font-semibold text-slate-800 mb-1">Accedi</h2>
          <p className="text-sm text-slate-500 mb-6">Inserisci le credenziali del tuo account.</p>
          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <div>
              <label htmlFor="login-email" className="block text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1.5">Email</label>
              <input
                id="login-email"
                data-testid="login-email-input"
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-3 py-2.5 text-sm bg-white border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-900/30 focus:border-blue-900 transition-colors"
                placeholder="nome@studio.it"
              />
            </div>
            <div>
              <label htmlFor="login-password" className="block text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1.5">Password</label>
              <input
                id="login-password"
                data-testid="login-password-input"
                type="password"
                required
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-3 py-2.5 text-sm bg-white border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-900/30 focus:border-blue-900 transition-colors"
                placeholder="••••••••"
              />
            </div>
            {error && (
              <div data-testid="login-error" className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-md px-3 py-2">
                {error}
              </div>
            )}
            <button
              type="submit"
              data-testid="login-submit-button"
              disabled={loading}
              className="w-full py-2.5 bg-blue-900 text-white text-sm font-semibold rounded-md hover:bg-blue-950 disabled:opacity-60 transition-colors"
            >
              {loading ? "Accesso in corso…" : "Accedi al gestionale"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
